import React from "react";
import SEO from "./SEO";

export const About = ({ data, lang = 'tr' }) => {
  const about = data;

  if (!about) return null;

  // SEO content based on language
  const seoContent = {
    tr: {
      title: "Ana Sayfa",
      description: "Akay Conseil - Profesyonel hukuk danışmanlığı hizmetleri. İş hukuku, şirketler hukuku, aile hukuku ve daha fazlası için uzman ekibimizle iletişime geçin.",
      keywords: "hukuk, avukat, danışmanlık, iş hukuku, şirketler hukuku, aile hukuku, ceza hukuku, gayrimenkul hukuku, adana avukat"
    },
    en: {
      title: "Home",
      description: "Akay Conseil - Professional legal consulting services. Contact our expert team for labor law, corporate law, family law and more.",
      keywords: "law, lawyer, legal consulting, labor law, corporate law, family law, criminal law, real estate law, adana lawyer"
    },
    fr: {
      title: "Accueil",
      description: "Akay Conseil - Services de conseil juridique professionnels. Contactez notre équipe d'experts pour le droit du travail, le droit des sociétés, le droit de la famille et plus encore.",
      keywords: "droit, avocat, conseil juridique, droit du travail, droit des sociétés, droit de la famille, droit pénal, droit immobilier"
    },
    ku: {
      title: "Rûpela Sereke",
      description: "Akay Conseil - Karûbarên şêwirmendiya huqûqî yên profesyonel. Ji bo mafê karî, mafê pargîdaniyan, mafê malbatê û bêtir bi tîma pispor a me re têkilî pêk bînin.",
      keywords: "huqûq, parêzer, şêwirmendiya huqûqî, mafê karî, mafê pargîdaniyan, mafê malbatê, mafê cezayê, mafê xanîyan"
    }
  };

  const currentLang = lang ? lang.toLowerCase() : 'tr';
  const seo = seoContent[currentLang] || seoContent.tr;

  return (
    <div id="about">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        url="/"
        lang={currentLang}
        image="img/about-us.png"
      />
      {/* Container içinde TAM genişlik görsel */}
      <div className="container">
        <div className="about-hero-full">
          <img
            src="img/about-us.png"
            className="img-responsive"
            alt="About Us"
          />
        </div>
      </div>

      {/* Misyon ve Vizyon */}
      <div className="container">
        <div className="row" style={{ marginTop: '60px', marginBottom: '60px' }}>
          {/* Misyonumuz */}
          <div className="col-md-6 col-sm-12 px-0">
            <div className="mission-vision-box">
              <h2>{about.missionTitle}</h2>
              <p className="mission-vision-text">{about.missionText}</p>
            </div>
          </div>

          {/* Vizyonumuz */}
          <div className="col-md-6 col-sm-12 px-0">
            <div className="mission-vision-box">
              <h2>{about.visionTitle}</h2>
              <p className="mission-vision-text">{about.visionText}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};